/* 松栄堂楽器 オリジナルテーマ
   持たせるのは7つだけ: ドロワー / ドロワーのアコーディオン / エリアタブ /
   検索フォームの遷移 / フローティングCTAの出し入れ / モーダル /
   スクロールのフェードイン / 背景の装飾のフェードイン。
   検索結果の取得は行わない（明細#10 の Storefront API 実装が担当）。 */
(function () {
  'use strict';

  /* 1. ドロワー（SP） --------------------------------------------------- */
  function initDrawer() {
    const drawer = document.querySelector('[data-drawer]');
    const openers = document.querySelectorAll('[data-drawer-open]');
    if (!drawer || !openers.length) return;

    const closer = drawer.querySelector('[data-drawer-close]');
    let lastFocused = null;

    function setOpen(open) {
      drawer.dataset.open = String(open);
      drawer.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
      openers.forEach((b) => b.setAttribute('aria-expanded', String(open)));

      if (open) {
        lastFocused = document.activeElement;
        (closer || drawer).focus();
      } else if (lastFocused) {
        lastFocused.focus();
      }
    }

    openers.forEach((b) => b.addEventListener('click', () => setOpen(true)));
    if (closer) closer.addEventListener('click', () => setOpen(false));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') setOpen(false);
    });

    setOpen(false);
  }

  /* 2. ドロワー内のアコーディオン ---------------------------------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        /* ＋ / − は両方 DOM にあり、CSS が aria-expanded で出し分ける */
      });
    });
  }

  /* 2-2. FAQ の開閉アニメーション（2026-08-30 福水さん指示）---------------- */
  /* `<details>` は高さが遷移しないので、開閉を横取りして本文の高さと不透明度を
     Web Animations で動かす。閉じるときは**動き終わってから** `open` を外す
     （先に外すと中身が消えて何も見えない）。
     `prefers-reduced-motion` のときは何もせず既定の即時開閉に任せる。 */
  function initFaqAccordion() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    const DURATION = 260;
    const EASING = 'cubic-bezier(0.2, 0, 0, 1)';

    document.querySelectorAll('details.faq-item').forEach((item) => {
      const summary = item.querySelector('summary');
      const panel = item.querySelector('.faq-item__a');
      if (!summary || !panel) return;

      let anim = null;

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        /* 途中で押し返されたら、いまの値から続ける（0 へ飛ばさない）。
           走行中は computed も動いている値を返すので、cancel の**前**に読む。 */
        const running = getComputedStyle(panel);
        const fromH = anim || item.open ? panel.getBoundingClientRect().height : 0;
        const fromPT = anim ? running.paddingTop : (item.open ? running.paddingTop : '0px');
        const fromPB = anim ? running.paddingBottom : (item.open ? running.paddingBottom : '0px');

        if (anim) {
          anim.cancel();
          anim = null;
        }

        const opening = !item.open;
        if (opening) item.open = true;

        /* **上下のパディング（各24）も動かす**——`box-sizing: border-box` なので
           高さだけ 0 にしてもパディングぶん 48px 残り、そこで跳ねて見える */
        const base = getComputedStyle(panel);
        const toPT = opening ? base.paddingTop : '0px';
        const toPB = opening ? base.paddingBottom : '0px';
        const toH = opening ? panel.scrollHeight : 0;

        panel.style.overflow = 'hidden';

        anim = panel.animate(
          {
            height: [fromH + 'px', toH + 'px'],
            paddingTop: [fromPT, toPT],
            paddingBottom: [fromPB, toPB],
            opacity: opening ? [0, 1] : [1, 0],
          },
          { duration: DURATION, easing: EASING }
        );

        anim.onfinish = () => {
          panel.style.overflow = '';
          if (!opening) item.open = false;
          anim = null;
        };
      });
    });
  }

  /* 3. 教室のエリア（SP のセレクト）------------------------------------- */
  /* **その場で絞り込まない**——8/20 MTG の決着で、エリアは一覧ページへ遷移する
     （PC のタブは Liquid 側で素のリンクにしてあるので JS は要らない）。
     セレクトだけは選んだ時点で飛ばす必要があるのでここで受ける。 */
  function initAreaJump() {
    document.querySelectorAll('[data-area-jump]').forEach((select) => {
      select.addEventListener('change', () => {
        const base = select.dataset.areaUrl;
        if (!base || base === '#' || !select.value) return;
        /* `#search` は「絞り込み済みで入ってくる導線の着地点」＝検索パネルの直上。
           付けないとページ最上部の FV に降りて、絞り込まれていることに気づけない。 */
        location.href = base + '?area=' + encodeURIComponent(select.value) + '#search';
      });
    });
  }

  /* 4. 検索フォーム（条件をクエリにして一覧ページへ遷移） ---------------- */
  /* 2026-08-20 MTG 決定: 絞り込みは結果一覧ページへ遷移する */
  function initSearchForm() {
    document.querySelectorAll('[data-search-form]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        const required = form.querySelector('[data-required-select]');
        if (required && !required.value) {
          e.preventDefault();
          required.focus();
          form.querySelectorAll('[data-required-message]').forEach((m) => {
            m.hidden = false;
          });
          return;
        }

        /* 空の条件をクエリに載せない */
        form.querySelectorAll('select').forEach((sel) => {
          sel.disabled = sel.value === '';
        });

        /* 素の GET 送信だと `action` の `#search` が落ちる実装があるので、
           こちらで URL を組み立てて飛ばす（着地点は検索パネルの直上）。 */
        e.preventDefault();
        const params = new URLSearchParams(new FormData(form));
        const base = (form.getAttribute('action') || '/').split('#')[0];
        const qs = params.toString();
        location.href = base + (qs ? '?' + qs : '') + '#search';
      });
    });
  }

  /* 5. フローティングCTA（SP）。常時表示し、フッターが見えたら隠す ------- */
  function initFloatingCta() {
    const bar = document.querySelector('[data-floating-cta]');
    const footer = document.querySelector('.footer');
    if (!bar || !footer || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          bar.dataset.hidden = String(e.isIntersecting);
        });
      },
      /* フッターが画面に入る少し前から隠し始める */
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );
    io.observe(footer);
  }

  /* 6. モーダル（ヘッダーの Instagram ポップアップ）---------------------- */
  /* 開く側は [data-modal-open="<モーダルのid>"]、閉じる側は [data-modal-close]。
     外部APIは使わず、DOM に置いてあるものを出し入れするだけ。 */
  function initModals() {
    const openers = document.querySelectorAll('[data-modal-open]');
    if (!openers.length) return;

    let lastFocused = null;

    function setOpen(modal, open) {
      modal.dataset.open = String(open);
      modal.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';

      document
        .querySelectorAll('[data-modal-open="' + modal.id + '"]')
        .forEach((b) => b.setAttribute('aria-expanded', String(open)));

      if (open) {
        lastFocused = document.activeElement;
        const dialog = modal.querySelector('[role="dialog"]');
        (dialog || modal).focus();
      } else if (lastFocused) {
        lastFocused.focus();
      }
    }

    openers.forEach((opener) => {
      const modal = document.getElementById(opener.dataset.modalOpen);
      if (!modal) return;

      opener.addEventListener('click', () => setOpen(modal, true));

      modal.querySelectorAll('[data-modal-close]').forEach((c) => {
        c.addEventListener('click', () => setOpen(modal, false));
      });

      setOpen(modal, false);
    });

    /* Esc は開いているものだけ閉じる */
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-modal][data-open="true"]').forEach((m) => setOpen(m, false));
    });
  }

  /* 7. スクロールでのフェードイン ---------------------------------------- */
  /* 対象は main 直下のセクション。**FV（最初のセクション）は外す**——初期表示で
     既に画面内にあり、フェードさせると読み込み直後にちらつく。
     IntersectionObserver が無い環境・reduce motion では何もしない
     （data-reveal を付けないので CSS も効かない＝最初から見えている）。 */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targets = Array.from(document.querySelectorAll('#main > *')).slice(1);
    if (!targets.length) return;

    targets.forEach((el) => {
      el.dataset.reveal = '';
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.dataset.revealed = 'true';
          io.unobserve(e.target);
        });
      },
      /* 少し画面に入ってから動かす（下端で一瞬だけ見えて動くのを避ける） */
      { rootMargin: '0px 0px -12% 0px', threshold: 0 }
    );

    targets.forEach((el) => io.observe(el));
  }

  /* 8. 背景の装飾のフェードイン ------------------------------------------ */
  /* セクションの reveal（7）に相乗りさせず、**装飾そのものが画面に入ったとき**に出す。
     相乗りだと縦に長いセクションで「上端で発火 → 下の装飾が視界に来る頃には
     終わっている」ため、独立して動いて見えない（教室検索の右下がそれ）。
     FV の装飾は読み込み時に出すので対象外（CSS の `.has-js .decor-reveal` が担当）。
     遅延は同じ wrapper 内の順番で 120ms ずつ。 */
  function initDecorReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const wraps = document.querySelectorAll('.section__decor, .section__decor--sp');
    if (!wraps.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.dataset.decorRevealed = 'true';
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );

    wraps.forEach((wrap) => {
      wrap.querySelectorAll('img').forEach((img, i) => {
        img.dataset.decorReveal = '';
        img.style.setProperty('--decor-delay', i * 120 + 'ms');
        io.observe(img);
      });
    });
  }

  /* 9. レッスン一覧の絞り込み・並べ替え（明細#7・#10）--------------------- */
  /* ⚠ **Liquid はクエリ文字列を読めない**（2026-08-29 実測。`request.get_params` は
     存在せず、`?category=` を付けても Liquid 側からは見えない）。ブログはタグ専用の
     ルートが使えるが、メタオブジェクトには無いので**全件を出して JS で絞る**。
     URL は history.replaceState で同期する＝絞り込んだ状態を共有・ブックマークでき、
     ブラウザの戻るも効く（2026-08-29「一覧ページ内で絞り込み」の実装）。
     絞り込みの軸は Figma の検索パネル（node 84:1492）どおり5つ——
     カテゴリ・年齢・エリア・キーワード・「無料体験ができるコースのみ」。 */
  /* `#search` で入ってきたときの着地（絞り込み済みの導線だけが付けてくる）。
     **ブラウザ任せにできない**——一覧の JS は初期化のたびに `history.replaceState` で
     URL を組み直してハッシュを落とすので、素のフラグメント移動が消える。
     さらに絞り込みで一覧の高さが変わるため、描画を終えてから自分で寄せる。
     着地点は検索パネルの直上（`<div id="search">`）で、固定ヘッダーぶんの余白は
     CSS の `.scroll-anchor { scroll-margin-top }` が持つ。 */
  /* 絞り込み済みで入ってくる導線の着地点。`#search` は検索パネルの直上
     （レッスン一覧・教室一覧）、`#news-list` はタブ列の直上（お知らせ一覧）。
     ⚠ **ハッシュはスクリプトの読み込み時に控える**——一覧の初期描画が
     `history.replaceState` で URL を組み直してハッシュを落とすため、
     着地の判定を後から `location.hash` で行うと必ず空になる（2026-09-16 実測）。 */
  /* 別ページから `#…` 付きで入ってきたときの着地点。**id を名簿で絞らない**
     ——`#search` `#news-list` だけを見ていたので、`#trial` `#classrooms-list`
     `#available-lessons` やよくある質問のカテゴリーは飛んできてもページ先頭のままだった
     （2026-09-16 実測）。ブラウザ本来のジャンプが効かないのは下のコメントの理由による。 */
  let LANDING_ID = '';
  try { LANDING_ID = decodeURIComponent(location.hash.slice(1)); } catch (e) { LANDING_ID = location.hash.slice(1); }

  let landed = false;

  function landOnHash() {
    if (!LANDING_ID || landed) return;
    const target = document.getElementById(LANDING_ID);
    if (!target) return;
    landed = true;

    /* ⚠ **一度では決まらない**（2026-09-16 実測——教室一覧とお知らせ一覧で
       最下部まで流れた）。絞り込みで items が `hidden` になり、遅延読み込みの
       画像・カルーセルが後から高さを変えるので、描画直後に寄せても位置が動く
       （ブラウザのスクロールアンカリングも効く）。**落ち着くまで数回寄せ直す**。
       人が自分でスクロールしたらそこで止める（勝手に引き戻さない）。 */
    let live = true;
    const stop = () => { live = false; };
    ['wheel', 'touchstart', 'keydown'].forEach((ev) => {
      window.addEventListener(ev, stop, { once: true, passive: true });
    });

    const go = () => { if (live) target.scrollIntoView({ block: 'start' }); };

    /* **位置が合うまで寄せ直す**——高さの変化だけを見ていると、
       別ページからのリンクで入ったときに**ブラウザが後からスクロール位置を 0 へ戻す**
       ことがあり（2026-09-16 実測。再読み込みでは起きず、リンク遷移でだけ起きた）、
       高さが動かない回は一度も直せなかった。**狙いの位置からずれていたら寄せ直す**。 */
    const wanted = () => {
      const m = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      return Math.abs(target.getBoundingClientRect().top - m) > 2;
    };
    const tick = () => { if (wanted()) go(); };
    const timer = setInterval(tick, 100);
    setTimeout(() => { clearInterval(timer); stop(); }, 3000);

    requestAnimationFrame(() => requestAnimationFrame(go));
    window.addEventListener('load', go, { once: true });
  }

  function initLessonFilter() {
    const root = document.querySelector('[data-lesson-filter]');
    const grid = document.querySelector('[data-lesson-grid]');
    if (!root || !grid) return;

    const items = Array.from(grid.querySelectorAll('[data-lesson-item]'));
    const selects = Array.from(root.querySelectorAll('select[data-filter-key]'));
    const keywordEl = root.querySelector('input[data-filter-key="keyword"]');
    const trialEl = root.querySelector('input[data-filter-key="trial"]');
    const sortEl = root.querySelector('[data-lesson-sort]');
    const countEl = root.querySelector('[data-filter-count]');
    const appliedRow = root.querySelector('[data-applied-row]');
    const appliedTags = root.querySelector('[data-applied-tags]');
    const emptyEl = root.querySelector('[data-filter-empty]');

    /* 選択状態を URL から復元する（TOP の検索ブロックからの遷移がここに入る） */
    const params = new URLSearchParams(location.search);
    selects.forEach((sel) => {
      const v = params.get(sel.dataset.filterKey);
      if (v) sel.value = v;
    });
    /* 種別（ヤマハ／オリジナル）は面にセレクトを置いていない（支給デザインに無い）。
       URL の ?type= とチップからだけ効く。 */
    let lessonType = params.get('type') || '';
    if (keywordEl && params.get('q')) keywordEl.value = params.get('q');
    if (trialEl && params.get('trial') === '1') trialEl.checked = true;
    if (sortEl && params.get('sort')) sortEl.value = params.get('sort');

    const conditions = () => {
      const c = {};
      selects.forEach((sel) => { if (sel.value) c[sel.dataset.filterKey] = sel.value; });
      if (lessonType) c.type = lessonType;
      if (keywordEl && keywordEl.value.trim()) c.q = keywordEl.value.trim();
      if (trialEl && trialEl.checked) c.trial = '1';
      return c;
    };

    const matches = (item, c) => {
      if (c.type && item.dataset.type !== c.type) return false;
      if (c.category && item.dataset.category !== c.category) return false;
      if (c.age && !(item.dataset.age || '').split('|').includes(c.age)) return false;
      if (c.area && !(item.dataset.areas || '').split('|').includes(c.area)) return false;
      if (c.trial && item.dataset.trial !== '1') return false;
      if (c.q && (item.dataset.keyword || '').indexOf(c.q) === -1) return false;
      return true;
    };

    const syncUrl = (c) => {
      const p = new URLSearchParams();
      if (c.type) p.set('type', c.type);
      ['category', 'age', 'area'].forEach((k) => { if (c[k]) p.set(k, c[k]); });
      if (c.q) p.set('q', c.q);
      if (c.trial) p.set('trial', '1');
      if (sortEl && sortEl.value !== 'recommended') p.set('sort', sortEl.value);
      if (page > 1) p.set('page', page);
      const qs = p.toString();
      history.replaceState(null, '', qs ? location.pathname + '?' + qs : location.pathname);
    };

    /* 適用中の条件（node 84:1544）。表示だけで、押しても何も起きない
       （デザインに削除の × が無い＝条件は上の検索パネルで変える）。
       アイコンは面に在る mdi:tag（チップと同じもの）を複製して使う
       ——JS からは Liquid の render を呼べないため。 */
    const tagIconSource = root.querySelector('.search-chips .icon--tag, .icon--tag');
    const tagIcon = tagIconSource ? tagIconSource.outerHTML : '';
    /* 適用中の条件（node 84:1544）。押すとその条件だけ外せる */
    const renderApplied = (c) => {
      if (!appliedRow || !appliedTags) return;
      const keys = ['type', 'category', 'age', 'area'].filter((k) => c[k]);
      if (c.q) keys.push('q');
      if (c.trial) keys.push('trial');
      if (!keys.length) {
        appliedRow.hidden = true;
        appliedTags.innerHTML = '';
        return;
      }
      /* デザイン（node 84:1544）はアイコン＋文字だけで、枠も削除の × も無い。
         条件どうしは「,」で区切る。条件を変えるのは上の検索パネル。 */
      appliedTags.innerHTML = keys
        .map((k) => {
          const label = k === 'q' ? c.q : k === 'trial' ? '無料体験あり' : c[k];
          return '<span class="applied-tag">' + tagIcon + '<span>' + label + '</span></span>';
        })
        .join('<span class="applied-tag__sep">,</span>');
      appliedRow.hidden = false;
    };

    const sortItems = (list) => {
      const mode = sortEl ? sortEl.value : 'recommended';
      return list.slice().sort((a, b) => {
        if (mode === 'name') return (a.dataset.name || '').localeCompare(b.dataset.name || '', 'ja');
        return (parseInt(a.dataset.sort, 10) || 9999) - (parseInt(b.dataset.sort, 10) || 9999);
      });
    };

    /* 検索は「この条件で探す」を押したときだけ走る（2026-08-30）。
       選んだ時点で結果が変わるとボタンの意味が無くなるため、
       画面のコントロール＝下書き、committed＝適用済み、と分けている。
       並び替えは条件ではないので下書きを確定させず、その場で並べ替えるだけ。 */
    let committed = {};

    /* ページャー（2026-08-31）。デザインは結果5件で描かれていて存在しないので、
       **お知らせ一覧のページャー（node 84:1413）と同じ見た目**を JS で組む
       （`.pager` 系の CSS は共用・`snippets/pager.liquid` の但し書きどおり）。
       Shopify の `paginate` は使えない——メタオブジェクトを JS で絞った配列には
       当てられず、そもそも Liquid はクエリを読めない。
       絞り込み・並べ替えを変えたら1ページ目へ戻す（別の条件の3ページ目に居ても意味がない）。 */
    const pagerEl = document.querySelector('[data-lesson-pager]');
    const perPage = parseInt((grid.dataset.perPage || '10'), 10) || 10;
    let page = parseInt(params.get('page'), 10) || 1;

    /* 1 … 4 5 6 … 12 の形にする（両端と現在地の前後だけ出す） */
    const pageParts = (total, cur) => {
      const out = [];
      for (let i = 1; i <= total; i += 1) {
        if (i === 1 || i === total || (i >= cur - 1 && i <= cur + 1)) out.push(i);
        else if (out[out.length - 1] !== '…') out.push('…');
      }
      return out;
    };

    const renderPager = (total, cur) => {
      if (!pagerEl) return;
      if (total <= 1) { pagerEl.hidden = true; pagerEl.innerHTML = ''; return; }
      const nav = (label, to, off) =>
        off
          ? '<span class="pager__nav pager__nav--off" aria-hidden="true">' + label + '</span>'
          : '<button type="button" class="pager__nav" data-page="' + to + '">' + label + '</button>';
      const nums = pageParts(total, cur)
        .map((p) => {
          if (p === '…') return '<li><span class="pager__num pager__num--off">…</span></li>';
          if (p === cur) return '<li><span class="pager__num pager__num--current" aria-current="page">' + p + '</span></li>';
          return '<li><button type="button" class="pager__num" data-page="' + p + '">' + p + '</button></li>';
        })
        .join('');
      pagerEl.innerHTML = nav('前へ', cur - 1, cur <= 1) + '<ul class="pager__list">' + nums + '</ul>' + nav('次へ', cur + 1, cur >= total);
      pagerEl.hidden = false;
    };

    const render = () => {
      const c = committed;
      const hit = items.filter((el) => matches(el, c));
      const sorted = sortItems(hit);

      /* 並べ替えは DOM ごと入れ替える（絞り込みを外したときの並びも指定どおりになる） */
      sorted.forEach((el) => grid.appendChild(el));

      const total = Math.max(1, Math.ceil(sorted.length / perPage));
      if (page > total) page = total;
      if (page < 1) page = 1;
      const from = (page - 1) * perPage;
      const shownNow = sorted.slice(from, from + perPage);
      items.forEach((el) => { el.hidden = shownNow.indexOf(el) === -1; });

      /* 件数は**絞り込みの結果ぜんぶ**（ページ内の数ではない） */
      if (countEl) countEl.textContent = hit.length + '件のレッスン案内が見つかりました';
      if (emptyEl) emptyEl.hidden = hit.length !== 0;
      renderPager(sorted.length ? total : 1, page);
      renderApplied(c);
      syncUrl(c);
    };

    if (pagerEl) {
      pagerEl.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-page]');
        if (!btn) return;
        page = parseInt(btn.dataset.page, 10) || 1;
        render();
        grid.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    }

    const apply = () => {
      committed = conditions();
      page = 1;
      render();
    };

    /* ※必須（カテゴリ）。押せなくするのではなく、押したら理由を出して止める。
       チップと URL からの遷移は当社が用意した検索なので通す。 */
    const requiredEl = root.querySelector('[data-filter-required]');
    const errorEl = root.querySelector('[data-filter-error]');

    const clearError = () => {
      if (errorEl) errorEl.hidden = true;
      if (requiredEl) requiredEl.removeAttribute('aria-invalid');
    };

    const validate = () => {
      if (!requiredEl || requiredEl.value) {
        clearError();
        return true;
      }
      if (errorEl) errorEl.hidden = false;
      requiredEl.setAttribute('aria-invalid', 'true');
      requiredEl.focus();
      return false;
    };

    /* 0件の予告（2026-08-30）。下書きの条件で1件も無いときだけ出す
       ——毎回件数を出すと押す前に答えが分かってボタンの意味が薄れる。 */
    const previewEl = root.querySelector('[data-filter-preview]');

    /* 条件をクリア（デザインには無い追加）。**実際に検索したときだけ出す**
       ——選んだだけ（下書き）では出さない（2026-08-30 福水さん指示）。
       消す対象が画面に出ていない状態でボタンだけ在るのを避ける。 */
    const clearBtn = root.querySelector('[data-filter-clear]');

    const updateClear = () => {
      if (!clearBtn) return;
      clearBtn.hidden = Object.keys(committed).length === 0;
    };

    const updatePreview = () => {
      if (previewEl) {
        const c = conditions();
        const empty = !items.some((el) => matches(el, c));
        previewEl.hidden = !empty;
      }
      updateClear();
    };

    /* 検索する（ボタン・Enter・チップから呼ぶ）。止まったらスクロールもしない */
    const search = (skipValidation) => {
      if (!skipValidation && !validate()) return false;
      clearError();
      apply();
      updatePreview();
      grid.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return true;
    };

    /* セレクト・キーワード・チェックは下書きを変えるだけ（結果は動かさず、
       0件になるかどうかだけ知らせる） */
    selects.forEach((sel) => sel.addEventListener('change', updatePreview));
    if (trialEl) trialEl.addEventListener('change', updatePreview);
    if (keywordEl) keywordEl.addEventListener('input', updatePreview);
    if (sortEl) sortEl.addEventListener('change', () => { page = 1; render(); });
    if (keywordEl) {
      keywordEl.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          search();
        }
      });
    }

    /* 「よく検索される条件」のチップは条件をまとめて入れる */
    root.querySelectorAll('[data-chip-type], [data-chip-category], [data-chip-age], [data-chip-area]').forEach((chip) => {
      chip.addEventListener('click', () => {
        lessonType = chip.dataset.chipType || '';
        selects.forEach((sel) => {
          const v = chip.dataset['chip' + sel.dataset.filterKey.charAt(0).toUpperCase()
            + sel.dataset.filterKey.slice(1)];
          sel.value = v || '';
        });
        /* チップは条件が揃った検索なので、必須の検査は通す */
        search(true);
      });
    });

    const submit = root.querySelector('[data-filter-submit]');
    if (submit) submit.addEventListener('click', () => search());

    /* 選び直したらその場でエラーを消す（押し直しを待たせない） */
    if (requiredEl) requiredEl.addEventListener('change', clearError);

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        /* 下書きも適用済みも両方戻す（並び替えは条件ではないので触らない） */
        selects.forEach((sel) => { sel.value = ''; });
        if (keywordEl) keywordEl.value = '';
        if (trialEl) trialEl.checked = false;
        lessonType = '';
        committed = {};
        clearError();
        render();
        updatePreview();
      });
    }

    apply();
    updatePreview();
    landOnHash();
  }

  /* カルーセル（2026-08-30 近藤様 Figmaコメント #9 / #11）。
     位置は CSS のスクロールスナップが持ち、JS は「何ページあるか」と送りだけを見る
     ——1枚の幅を JS で決めると SP/PC の切り替えでずれる。
     1ページ = 1画面ぶん＋隙間1つ（3枚見せなら4枚目の左端が次ページの先頭）。 */
  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach((root) => {
      const track = root.querySelector('[data-carousel-track]');
      if (!track || !track.children.length) return;

      const prev = root.querySelector('[data-carousel-prev]');
      const next = root.querySelector('[data-carousel-next]');
      const dotsBox = root.querySelector('[data-carousel-dots]');
      const count = track.children.length;

      const gap = () => parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = () => track.clientWidth + gap();
      const pages = () => Math.max(1, Math.ceil(track.scrollWidth / step()));
      const index = () => Math.round(track.scrollLeft / step());

      let dots = [];

      const buildDots = () => {
        if (!dotsBox) return;
        const total = pages();
        if (dots.length === total) return;
        dotsBox.textContent = '';
        dots = [];
        for (let i = 0; i < total; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'carousel__dot';
          dot.setAttribute('aria-label', `${i + 1}ページ目を見る`);
          dot.addEventListener('click', () => {
            track.scrollTo({ left: i * step(), behavior: 'smooth' });
          });
          dotsBox.appendChild(dot);
          dots.push(dot);
        }
      };

      /* data-carousel-always: 1ページに収まっていても矢印を出す（無効化だけする）。
         講師カルーセル（教室詳細 node 108:3564）はデザインが矢印を常に持つ */
      const always = root.hasAttribute('data-carousel-always');

      const sync = () => {
        const total = pages();
        const at = Math.min(index(), total - 1);
        /* 1ページに収まるなら操作子ごと畳む（見えているものは全部なので送る先が無い） */
        const many = total > 1;
        [prev, next].forEach((btn) => { if (btn) btn.hidden = always ? false : !many; });
        if (dotsBox) dotsBox.hidden = !many;
        if (!many) {
          if (always) { if (prev) prev.disabled = true; if (next) next.disabled = true; }
          return;
        }
        if (prev) prev.disabled = at <= 0;
        if (next) next.disabled = at >= total - 1;
        dots.forEach((dot, i) => {
          if (i === at) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      if (prev) prev.addEventListener('click', () => { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', () => { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; sync(); });
      }, { passive: true });

      const refresh = () => { buildDots(); sync(); };
      refresh();
      if (count > 1 && 'ResizeObserver' in window) {
        new ResizeObserver(refresh).observe(track);
      } else {
        window.addEventListener('resize', refresh);
      }
    });
  }

  /* 10. 教室・店舗一覧のエリア絞り込み（node 344:8605） -------------------- */
  /* Liquid はクエリを読めないので全件出して JS で絞る（レッスン一覧と同じ作り）。
     入口は3つ——エリアのボタン・URL の ?area=・TOP や他ページの
     「エリアを選択」セレクト（initAreaJump がこのページへ ?area= で飛ばす）。
     ページャーは無い（2026-09-04 福水さん判断＝エリアで絞る前提）。 */
  function initClassroomFilter() {
    const root = document.querySelector('[data-classroom-filter]');
    const list = root && root.querySelector('[data-classroom-list]');
    if (!root || !list) return;

    const items = Array.from(list.querySelectorAll('[data-classroom-item]'));
    const buttons = Array.from(root.querySelectorAll('[data-area-btn]'));
    const applied = root.querySelector('[data-classroom-applied]');
    const appliedText = root.querySelector('[data-classroom-applied-text]');
    const resetBtn = root.querySelector('[data-classroom-reset]');
    const emptyEl = root.querySelector('[data-classroom-empty]');

    /* ボタンの文字ではなく data-area-btn（＝メタオブジェクトのエリア）で当てる */
    const labelOf = (area) => {
      const btn = buttons.find((b) => b.dataset.areaBtn === area);
      return btn ? btn.textContent.trim() : area;
    };

    const apply = (area, push) => {
      let shown = 0;
      items.forEach((item) => {
        const hit = !area || item.dataset.area === area;
        item.hidden = !hit;
        if (hit) shown += 1;
      });

      buttons.forEach((b) => {
        const on = !!area && b.dataset.areaBtn === area;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
      });

      if (applied && appliedText) {
        applied.hidden = !area;
        if (area) appliedText.textContent = '「' + labelOf(area) + '」の教室 ' + shown + '件';
      }
      if (emptyEl) emptyEl.hidden = shown !== 0;

      if (push) {
        const qs = area ? '?area=' + encodeURIComponent(area) : '';
        history.replaceState(null, '', location.pathname + qs);
      }
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        /* 選択中のボタンをもう一度押したら解除（絞り込みを外す手が2つある） */
        const next = btn.getAttribute('aria-pressed') === 'true' ? '' : btn.dataset.areaBtn;
        apply(next, true);
      });
    });

    if (resetBtn) resetBtn.addEventListener('click', () => apply('', true));

    apply(new URLSearchParams(location.search).get('area') || '', false);
    landOnHash();
  }

  function init() {
    initDrawer();
    initAccordions();
    initFaqAccordion();
    initAreaJump();
    initSearchForm();
    initFloatingCta();
    initModals();
    initScrollReveal();
    initDecorReveal();
    initLessonFilter();
    initClassroomFilter();
    /* お知らせ一覧はタグ絞り込みがサーバー側なので専用の初期化を持たない。
       着地だけここで受ける（対象が無ければ何もしない）。 */
    landOnHash();
    initCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
